export default __webpack_public_path__ + "static/media/logo_konbini.f0a61044.svg";